// extracted by mini-css-extract-plugin
export default {"menuBlock":"UG-z","title":"VG-z","nav":"WG-z","flexCell":"XG-z","facetLink":"YG-z"};